import type { Game, GameRaw, RandomGameDetails, RandomGameDetailsRaw } from '@/types';
import { getRandomVibrantColor, generateGradient } from '@/helpers/colorHelper';

export const gameAdapter = {
    mapGame(game: GameRaw): Game {
        const cardBg = getRandomVibrantColor();
        const cardGradient = generateGradient(cardBg);

        return {
            ...game,
            isOpen: false,
            cardBg,
            cardGradient
        };
    },
    mapRandomGame(game: RandomGameDetailsRaw): RandomGameDetails {
        return {
            ...game,
            isOpen: false,
            cardBg: getRandomVibrantColor(),
            cardGradient: generateGradient(getRandomVibrantColor())
        };
    }
};
